module.exports = __webpack_public_path__ + "assets/img/0463.e4aad981.png";